'use strict';

var app = angular.module('analytics');

app.controller('CategoryPanelCtrl', [
    '$scope',
    'categoryFactory',
    'categoryScope',
    function ($scope, categoryFactory, categoryScope) {
        $scope.selectedCat = categoryFactory.getSelectedCategory();
        $scope.categoryScope = categoryFactory.getCategoryScope();

        $scope.save = function() {
            if($scope.selectedCat.id) { //modify
                categoryFactory.modify($scope.selectedCat.id, $scope.selectedCat);
            } else { //create
                categoryFactory.create($scope.selectedCat);
            }

            categoryScope.closePanel();
        }
}]);
//# sourceMappingURL=reportCtrl.js.map